// 数据大屏
export const bigScreenView = [
  {
    path: '/big-screen-view-1',
    name: 'BigScreenView1',
    component: () => import('./views/data-screen-view/1.vue'),
    meta: {
      title: '云南大屏一'
    }
  },
  {
    path: '/big-screen-view-2',
    name: 'BigScreenView2',
    component: () => import('./views/data-screen-view/2.vue'),
    meta: {
      title: '云南大屏二'
    }
  }
]

// 大屏数据管理模块
export const bigScreenDataManagement = [
  {
    path: 'big-screen-data-management',
    name: 'BigScreenDataManagement',
    component: () => import('./views/data-management/index.vue'),
    meta: {
      title: '大屏数据管理'
    }
  }
]
